export const useUnleashManager = () => useNuxtApp().$unleashManager;
